import { useCallback, useEffect, useMemo, useState } from 'react';

import { cmApi } from '../../../../api';
import { dataControlStore } from '../../../../stores/dataControlStore';
import type { TableComponentRequestDto } from '../../../../api';

interface IData {
  report_package_code_cm?: string;
  status?: string;
  status_out?: string;
  ctrl_vers?: string;
  ctrl_vers_ext?: string;
  step_code_ext?: string;
  formula?: string;
  step_name?: string;
  step_desc?: string;
  ctrl_vers_desc?: string;
  ctrl_name?: string;
  exec_num?: string;
  user_kp?: string;
  date_kp?: string;
  kscode_fns?: string;
  date_user_period_kp?: string;
}

export const useUpdateTitle = (): { titleData: IData; updateTitle: () => void } => {
  const [titleData, setTitleData] = useState<IData>({});

  const { lastPagesParam } = dataControlStore;

  const updateTitle = useCallback(() => {
    const tableInfo = {
      aggregate: {},
      fields: [
        'report_package_code_cm',
        'status',
        'status_out',
        'ctrl_vers',
        'ctrl_vers_ext',
        'ctrl_vers_desc',
        'step_code_ext',
        'formula',
        'step_name',
        'step_desc',
        'ctrl_name',
        'kscode_fns',
        'date_user_period_kp',
      ],
      hardFilter: lastPagesParam.filters,
      filter: [],
      groupBy: [],
      limit: 1,
      offset: 0,
      openGroup: [],
      orderBy: [],
      resource: 'v_ctrl_ctrl',
    };

    cmApi.tableComponentV2.getTableJson(tableInfo as unknown as TableComponentRequestDto).then((response) => {
      const result = response?.data as unknown as { data: IData };

      if (result && result.data) {
        setTitleData(result.data[0]);
      }
    });
  }, [lastPagesParam.filters]);

  useEffect(() => {
    updateTitle();
  }, [updateTitle]);

  return useMemo(() => ({ titleData, updateTitle }), [titleData, updateTitle]);
};
